import React from "react";
import { motion } from "framer-motion";
import { getCityCardMode } from "../../utils";

const CityDragCard = ({
  cityName,
  completed = false,
  correctAnswer,
  showAnswer,
}) => {
  const mode = getCityCardMode(cityName, correctAnswer, completed);

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      className={`transition-color mr-4 w-full cursor-pointer items-start justify-center overflow-hidden rounded-r-xl border-2 border-slate-300 bg-slate-200 p-2 pl-4 pr-2 text-left shadow dark:border-slate-400  dark:bg-slate-600 ${
        [
          " !dark:bg-majky-700 !dark:border-majky-500  pointer-events-none  !border-majky-600 !bg-majky-200 !text-majky-600 dark:!bg-majky-950 ",
          " !dark:bg-red-600 !dark:border-red-400  pointer-events-none  !border-red-600 !bg-red-200 !text-red-600 dark:!bg-red-950 ",
        ][showAnswer ? 0 : mode]
      } select-none  hover:border-blue-600 hover:bg-blue-200 hover:font-bold hover:text-blue-800 dark:hover:!bg-blue-950 hover:dark:text-slate-100 ${
        completed && "pointer-events-none"
      }`}
    >
      {completed && showAnswer ? correctAnswer.name : cityName}
    </motion.div>
  );
};

export default CityDragCard;
